import { lazy, Suspense } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import SeoServices from './components/SeoServices';
import WhySpecialist from './components/WhySpecialist';
import RecommendedSpecialist from './components/RecommendedSpecialist';
import { useSchemaOrg, usePageMeta } from '../../utils/seo';

const Services = lazy(() => import('./components/Services'));
const PianoTypes = lazy(() => import('./components/PianoTypes'));
const Coverage = lazy(() => import('./components/Coverage'));
const Testimonials = lazy(() => import('./components/Testimonials'));
const FAQ = lazy(() => import('./components/FAQ'));
const Contact = lazy(() => import('./components/Contact'));
const Footer = lazy(() => import('./components/Footer'));

export default function Home() {
  usePageMeta(
    'Piano Movers London | Expert Piano Removals London',
    'Expert piano movers in London and the Home Counties. Professional piano moving service fully insured to £5M. Grand pianos, uprights, digital pianos. Free quote today — call 020 3441 9463.',
    'piano movers UK, piano removal London, piano moving specialists, London piano movers, piano removal services',
    'https://www.pianomovers.co.uk/',
    'Piano Movers London | Expert Piano Removals London',
    'Expert piano movers in London and the Home Counties. Professional piano moving service fully insured to £5M. Grand pianos, uprights, digital pianos. Free quote today — call 020 3441 9463.',
    'Piano Movers London | Expert Piano Removals London',
    'Expert piano movers in London and the Home Counties. Fully insured to £5M. Free quote — 020 3441 9463.'
  );

  useSchemaOrg({
    type: 'LocalBusiness',
    data: {
      '@type': 'Organization',
      name: 'Piano Movers UK',
      description: 'Independent information resource about piano removal services in London',
      url: 'https://pianomovers.co.uk',
      logo: 'https://pianomovers.co.uk/logo.png',
      areaServed: {
        '@type': 'City',
        name: 'London',
        '@id': 'https://en.wikipedia.org/wiki/London',
      },
    },
  });

  useSchemaOrg({
    type: 'WebPage',
    data: {
      '@type': 'WebSite',
      name: 'Piano Movers UK',
      url: 'https://pianomovers.co.uk',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: 'https://pianomovers.co.uk/?s={search_term_string}',
        },
        'query-input': 'required name=search_term_string',
      },
    },
  });

  useSchemaOrg({
    type: 'FAQPage',
    data: {
      mainEntity: [
        {
          '@type': 'Question',
          name: 'How much does it cost to move a piano in the UK?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Costs range from £80–£150 for local upright to £400–£800+ for nationwide grand piano. Get a fixed quote at www.pianomoveteam.co.uk',
          },
        },
        {
          '@type': 'Question',
          name: 'Are pianos insured during the move?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, fully covered up to £5 million Goods in Transit Insurance.',
          },
        },
        {
          '@type': 'Question',
          name: 'Can you move a piano up or down stairs?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, we use specialist stair-climbing equipment for any access situation.',
          },
        },
        {
          '@type': 'Question',
          name: 'Do you offer same-day piano moving in London?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, subject to availability. Contact us early morning for same-day bookings.',
          },
        },
        {
          '@type': 'Question',
          name: 'How do I prepare my piano for moving?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Nothing — our team handles all wrapping, disassembly and reassembly.',
          },
        },
        {
          '@type': 'Question',
          name: 'Which areas do you cover?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'We cover all Greater London boroughs and the Home Counties — Essex, Kent, Surrey, Hertfordshire, Middlesex and Buckinghamshire. Contact us to confirm coverage for your specific postcode.',
          },
        },
      ],
    },
  });

  return (
    <div className="bg-[#0e0d0b] text-white">
      <Navbar />
      <Hero />
      <TrustBar />
      <SeoServices />
      <WhySpecialist />
      <RecommendedSpecialist />
      <Suspense fallback={<div className="min-h-screen" />}>
        <Services />
        <PianoTypes />
        <Coverage />
        <Testimonials />
        <FAQ />
        <Contact />
        <Footer />
      </Suspense>
    </div>
  );
}